import { combineReducers } from '@reduxjs/toolkit';
import authReducer from 'reducers/app';
import dataTableReducer from 'services/dataList/reducer';
import professionEndPoint from 'endPoints/professions';
import errorReducer from 'reducers/error';
import professionReducer from 'reducers/profession';
import articlesReducer from 'reducers/articles';
import pagesReducer from 'reducers/pages';
import companyReducer from 'reducers/company';
import consultantsReducer from 'reducers/consultants';
import mentorsReducer from 'reducers/mentors';
import gamificationReducer from 'reducers/gamification';
import assessmentReducer from 'reducers/assessment';
import featuresReducer from 'reducers/features';

const combined = combineReducers({
  app: authReducer,
  error: errorReducer,
  profession: professionReducer,
  articles: articlesReducer,
  pages: pagesReducer,
  company: companyReducer,
  consultants: consultantsReducer,
  mentors: mentorsReducer,
  gamification: gamificationReducer,
  assessment: assessmentReducer,
  features: featuresReducer,
  [professionEndPoint.sourceName]: dataTableReducer(professionEndPoint)
});

// Public content/config slices survive logout; user-scoped slices are dropped so
// the next user on a shared tab can't read the previous user's data (app user,
// assessment result, gamification, consultants). Setting a key to undefined makes
// combineReducers re-initialise that slice.
const PRESERVED_ON_LOGOUT = [
  'profession',
  'articles',
  'pages',
  'company',
  'features',
  professionEndPoint.sourceName
];

const reducers = (state, action) => {
  if (action.type === 'LOGOUT' && state) {
    const preserved = {};
    for (const key of PRESERVED_ON_LOGOUT) preserved[key] = state[key];
    return combined(preserved, action);
  }
  return combined(state, action);
};

export default reducers;
